export default __webpack_public_path__ + "static/media/verhuur-en-beheer-tarieven-2.4cd4dc5d.jpg";